import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResolveEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../service/auth.service';
import { HttpCallHandleService } from './http-call-handle.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class JWTInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthService,
    private router: Router,
    private httpcallHandle: HttpCallHandleService
  ) {
    this.router.events.subscribe((event) => {
      // An event triggered at the end of the activation part of the Resolve phase of routing.
      if (event instanceof ResolveEnd) {
        // Cancel pending calls
        this.httpcallHandle.cancelPendingRequests();
      }
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const url = `${request.url}`;
    const token: any = this.authenticationService.getToken();
    const skipToken = request.headers.get('skipToken') || false;
    const modifiedUrl = environment.apiUrl + '/' + url.replace(/([^:]\/)\/+/g, '$1');
    const requestD: any = { url: modifiedUrl };
    if (token && !skipToken) {
      requestD.setHeaders = {
        //'Content-Type': 'application/json',
        //'Accept': 'application/json',
        //'Access-Control-Allow-Origin': '*',
        //'X-AppName':  'Dcc',
        Authorization: 'Bearer ' + token,
      };
    }
    request = request.clone(requestD);
    return next
      .handle(request)
      .pipe(takeUntil(this.httpcallHandle.onCancelPendingRequests()));
  }
}
